import firebase from "@/generic_api/firebase/firebase";
import clonedeep from 'lodash.clonedeep'

const LOAD_ADDITIONAL_QUOTES_FROM_FAVQ = true;

// -----------------------------------------------------------------------------
export function quotes_onload({ commit }, author) {

  // console.log("quotes_onload");

  let quotes_data = window.localStorage['quotes_data']
  let quotes_last_update = window.localStorage['quotes_last_update']

  const CACHE_VALID_TIME = 48 * 60 * 60 * 1000; /* 48h in ms */
  // Using new Date here is ok!
  let cache_valid = new Date() - new Date(quotes_last_update) < CACHE_VALID_TIME;

  if ( quotes_data && cache_valid ) {

    console.log("[quotes] loading from cache", quotes_last_update);
    let idols = JSON.parse(quotes_data)
    commit('SET_IDOLS_AND_QUOTES', idols)

  } else {

    fetch_idols_from_firestore({ commit }).then((quote_data_obs) => {

      var quote_data = clonedeep(quote_data_obs);

      if ( LOAD_ADDITIONAL_QUOTES_FROM_FAVQ ) {
        let promise_list = [];
        quote_data.forEach(idol => {
          promise_list.push( fetch_quote_from_favqs({ commit }, idol.name, false ) )
        })
        Promise.all(promise_list).then((list) => {

          /* Add favq quotes to local list */
          for ( let i = 0; i < list.length; i++ ) {

            let favq_quotes = list[i];
            // console.log("favq_quotes", favq_quotes);

            if ( favq_quotes ) {

              let quotes_list = favq_quotes.map(item => item.body)

              quote_data[i].quotes.push(...quotes_list)
            }
          }

          // console.log("quote_data (enhanced)", quote_data);
          commit('SET_IDOLS_AND_QUOTES', quote_data)
          commit('QUOTES_SAVE_OFFLINE')
        })
      } else {
        commit('SET_IDOLS_AND_QUOTES', quote_data)
        commit('QUOTES_SAVE_OFFLINE')
      }

    });
  }
}

// -----------------------------------------------------------------------------
export function fetch_quote_from_favqs({ commit }, author, selectOneRandomly) {

  console.log("fetch_quote_from_favqs:", author);

  return new Promise((resolve, reject) => {

    let headers = new Headers({
      'Authorization': 'Token token="58551779c89ecf3d60b286679721cef5"'
    });

    let url = 'https://favqs.com/api/quotes/?filter=' +
              author.replace(" ", "+") +
              '&type=author';

    fetch(url, {

      method: 'get',
      headers: headers

    }).then((response) => {

      return response.json();

    }).then((data) => {

      console.log("fetch_quote_from_favqs: got quotes", data);

      if ( selectOneRandomly ) {
        let quote = data.quotes[Math.floor(Math.random() * 25)];
        resolve(quote)
      } else {
        resolve(data.quotes)
      }

    }).catch(reject)

  });
}

// -----------------------------------------------------------------------------
export function fetch_idols_from_firestore({ commit }) {

  console.log("fetch_idols_from_firestore");

  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref('idols')
      .limitToFirst(100)
      .once("value", (snapshot) => {

        let val = snapshot.val();
        let idols = [];
        if ( !val ) {
          // eslint-disable-next-line
          reject('IDOLS_DO_NOT_EXIST');
          return;
        }

        Object.keys(val).map(key => {
          idols.push({ id: key, ...val[key] });
        });

        commit('SET_IDOLS_AND_QUOTES', idols)
        resolve(idols);
      });
    })
}
